import {styled} from "@mui/material/styles"
import {mobileThreshold, portfolioWidth} from "../../../../Constants/layoutValues";
import {SectionTitle} from "../../HomePageStyles";

export const BlurbWrapper = styled('div')`
	font-size: 1.2rem;
	line-height: 1.6;
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 1rem;
	padding-bottom: 1rem;
	width: calc(100% - 2rem);
	@media (max-width: ${mobileThreshold}px)
	{
		width: calc(100% - 1rem);
		padding-left: .5rem;
		padding-right: .5rem;
	};
`
export const BlurbPara = styled('div')`
	padding-top: .5rem;
	padding-bottom: .5rem;
`;

export const Wrapper = styled('div')`
	
`;

export const Title= SectionTitle;

export const Content = styled('div')`
	
`;
